import { render, staticRenderFns } from "./TEXT_COMPONENT.vue?vue&type=template&id=2d14742a"
import script from "./TEXT_COMPONENT.vue?vue&type=script&lang=js"
export * from "./TEXT_COMPONENT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports